/**
 * DOCUMENTATION
 *
 * https://vuetifyjs.com/en/features/treeshaking/
 * https://vuetifyjs.com/en/features/icon-fonts/#material-design-icons---js-svg
 * https://vuetifyjs.com/en/features/internationalization/
 *
 */

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ca from 'vuetify/es5/locale/ca'
import en from 'vuetify/es5/locale/en'
import es from 'vuetify/es5/locale/es'
import fr from 'vuetify/es5/locale/fr'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {
      light: {
        primary: '#de5813',
        secondary: '#433733',
        accent: '#292321',
        error: '#de5813',
        info: '#eaa772',
        success: '#95BE31',
        warning: '#eed145',
      },
      dark: {
        primary: '#de5813',
        secondary: '#433733',
        accent: '#292321',
        error: '#de5813',
        info: '#eaa772',
        success: '#95BE31',
        warning: '#eed145',
      },
    },
    options: {
      variations: false, // https://vuetifyjs.com/en/features/theme/#variations
    },
  },
  lang: {
    locales: { ca, en, es, fr },
    current: 'en',
  },
})
